import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    Link,
    Redirect
} from 'react-router-dom';
import Toggle from "react-toggle";
import GlobalHelper from '../../common/GlobalHelper.jsx';
import ConfirmButton from '../../common/button/confirmbutton.component.jsx';
import ShopifyAppContext from '../../shopify/shopifyappcontext.js';
import { ROLE_EDIT_FORM_MESSAGES } from "../../utils/role/messages.ts";
import { Permissions } from '../Guard';
import PermissionLabel from "../permissionlabel.component.jsx";
import { RoleService } from "../services";

class RoleEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: this.props.role?.id ?? "",
            roleName: this.props.role?.attributes.key ?? "",
            permissions: this.props.role?.attributes.permissions ?? this.getDefaultPermissions(),
        }
        this.submit = this.submit.bind(this)
        this.handleFromChange = this.handleFromChange.bind(this)
        this.delete = this.delete.bind(this)
    }

    getDefaultPermissions() {
        const defaultPermissions = {};
        for (const key in Permissions) {
            defaultPermissions[Permissions[key]] = false
        }
        return defaultPermissions
    }

    getRoleName(){
        switch (this.state.roleName) {
            case "admin":
                return this.props.intl.formatMessage(ROLE_EDIT_FORM_MESSAGES.admin)
            case "sales-man":
                return this.props.intl.formatMessage(ROLE_EDIT_FORM_MESSAGES.salesMan)
            default:
                return this.state.roleName
        }
    }

    handleFromChange(event){
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    delete(event) {
        RoleService.delete(this.state.id).then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: "/roles/listing" }} /> })
            }
        })           
       event.preventDefault()
    }

    saveRole() {
        const payload = {
            roleName: this.state.roleName,
            permissions: this.state.permissions,
          }
        
        if (this.state.id) {              
            return RoleService.patch(this.state.id, payload)
        }else{ 
            return RoleService.post(payload)
        }
    }

    submit(event) {
        event.preventDefault()
        this.saveRole().then(response => {
            if (!response.error) {
                if (GlobalHelper.getShopifyIntegrationOrigin()) {
                    ShopifyAppContext.redirectTo('/roles/listing')
                } else {
                    this.setState({ formStatus: <Redirect to={{ pathname: '/roles/listing' }} /> }, () => {
                        window.location.reload()
                    })
                }

            }
        })
        event.preventDefault()
    }

    render() {
        const permissions = []

        for (let key in this.state.permissions) {
            permissions.push(
                <div className="form-group row" key={permissions.length}>
                    <label className="col-2 col-form-label text-align-right" htmlFor={key}>
                        <PermissionLabel value={key} />
                    </label>
                    <div className="col-10 mb-1 pt-2">
                        <Toggle
                            defaultChecked={this.state.permissions[key]}
                            checked={this.state.permissions[key]}
                            icons={false}
                            onChange={() => {
                                const perms = { ...this.state.permissions }
                                perms[key] = !this.state.permissions[key]
                                this.setState({
                                    permissions: perms,
                                })
                            }}
                        />
                    </div>
                </div>
            )
        }
        
        return (
            <form onSubmit={this.submit}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="roleName">
                                {this.props.intl.formatMessage(ROLE_EDIT_FORM_MESSAGES.role_label)}
                            </label>
                            <div className="col-10 mb-1 pt-2">
                                <input
                                    name="roleName"
                                    onChange={this.handleFromChange}
                                    value={this.getRoleName()}
                                    id="roleName"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.getRoleName()}
                                    disabled={this.props.role?.attributes.type === "system-defined"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 ui-module">
                        {permissions}
                    </div>
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                <ConfirmButton
                                    className="btn btn-danger"
                                    identifier={this.props.role?.attributes.roleName ?? ""}
                                    disabled={this.props.role ? this.props.role.attributes.type === "system-defined" : true}
                                    onClick={this.delete}>
                                    {this.props.intl.formatMessage(ROLE_EDIT_FORM_MESSAGES.delete_btn)}
                                </ConfirmButton>
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/roles/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="location.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(ROLE_EDIT_FORM_MESSAGES['save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default injectIntl(RoleEditForm)


// WEBPACK FOOTER //
// ./src/role/form/edit.component.jsx